import * as React from "react";
import PropTypes from "prop-types";
import { EMPTY } from "./Constants"; // still used as a placeholder or fallback

export default function OEIToggle({
  checked,
  onChange,
  disabled = false,
  label = "",
  errorMessage = EMPTY,
  name = "",
}) {
  const handleChange = () => {
    if (typeof onChange === "function") {
      onChange(!checked);
    }
  };

  return (
    <div className="m-top-10px m-bottom-0px" style={{ paddingBottom: "15px" }}>
      <label style={{ color: "#1A1A1A" }} className="switch">
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={handleChange}
          name={name}
        />
        <span className="slider round"></span>
      </label>
      <span className="line-height-25px">{label}</span>
      {errorMessage !== EMPTY && (
        <div className="oe-form-field__error">{errorMessage}</div>
      )}
    </div>
  );
}

OEIToggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  name: PropTypes.string,
};
